var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFlipkartIcon = function SvgFlipkartIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.994%",
    y1: "20.721%",
    x2: "49.994%",
    y2: "120.014%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC700",
    offset: "33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB600",
    offset: "78%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAB00",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.995%",
    y1: "101.727%",
    x2: "49.995%",
    y2: "47.871%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCB00",
    offset: "1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD800",
    offset: "14%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE600",
    offset: "34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB00",
    offset: "51%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0",
    offset: "78%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF800",
    offset: "98%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF900",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "95.226%",
    y1: "107.226%",
    x2: "39.696%",
    y2: "23.776%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7E830",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A520",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-93712.584%",
    y1: "64704.08%",
    x2: "-93466.386%",
    y2: "64408.753%",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7E830",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A520",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.928%",
    x2: "100%",
    y2: "49.928%",
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB00",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF900",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-121763.8%",
    y1: "63019.866%",
    x2: "-122263.8%",
    y2: "63019.866%",
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB00",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF900",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.312 32 .925-5.119h-3.583l-10.256-.376 9.428-.512-.127-.573-3.163-.45 3.006-.249-.2-.702-4.913-.732s5.343-.586 5.423-.586h5.167l.384-2.1c.464-2.53 1.51-4.4 3.156-5.788 1.646-1.388 3.747-2.09 6.291-2.09 1.029 0 1.67.236 1.97.729.213.42.363.868.445 1.331.137.46.188.94.15 1.418-.09.54-.731.729-1.91.729h-.408c-2.12 0-3.41 1.198-3.843 3.62l-.391 2.124h2.464c.919 0 1.25.633 1.002 2.047-.273 1.478-.861 2.134-1.776 2.134h-2.458l-.922 5.118-5.86.027z",
    fill: "#027CD5",
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.374.924 4.288.31c.197-.074.405-.112.615-.114H27.23c.227.002.452.038.668.107l1.67.616-.805.26c-.397.176-.534.332-.598.508l-.06.253v2.963H3.881V2.036a.837.837 0 0 0-.511-.746L2.368.984l.006-.06z",
    fill: "url(#a)",
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.579 1.74a.767.767 0 0 0-.825.715.82.82 0 0 0 .823.77.826.826 0 0 0 .824-.77.767.767 0 0 0-.822-.715zm-13.305 0a.767.767 0 0 0-.825.715.82.82 0 0 0 .823.77.826.826 0 0 0 .824-.77.763.763 0 0 0-.523-.678.77.77 0 0 0-.299-.037zM29.76 3.234V.881c0-.053-.043-.113-.18-.166l-1.77-.636a1.963 1.963 0 0 0-.648-.077H4.832a1.963 1.963 0 0 0-.647.077l-1.77.636c-.137.053-.177.113-.18.166v2.353L0 4.898v25.355a1.749 1.749 0 0 0 1.101 1.613c.215.086.444.13.676.127h13.622l.925-5.118h-3.597l-10.256-.377 9.425-.512-.124-.573-3.163-.449 3.006-.25-.2-.702-4.913-.732s5.344-.586 5.42-.586h5.167l.397-2.087c.461-2.529 1.51-4.4 3.156-5.787 1.646-1.388 3.747-2.09 6.292-2.09 1.028 0 1.67.236 1.967.728.215.42.366.868.447 1.332.135.46.186.94.15 1.418-.09.539-.734.728-1.913.728h-.404c-2.12 0-3.41 1.199-3.844 3.622l-.39 2.123h2.47c.919 0 1.25.632 1.003 2.047-.278 1.478-.862 2.133-1.78 2.133h-2.458l-.919 5.119h8.967c.463.002.909-.179 1.24-.502.33-.323.52-.764.527-1.225V4.905l-2.238-1.67zM28.55 1.237a.819.819 0 0 0-.46.47.165.165 0 0 1 0 .043.143.143 0 0 1 0 .036v.084a.126.126 0 0 1 0 .033v2.949H3.96v-2.95a.794.794 0 0 0-.507-.711L2.528.91 4.231.339c.197-.07.403-.107.611-.11h22.332c.227 0 .452.036.668.103l1.583.632-.875.273z",
    fill: "url(#b)",
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.287 1.663a.847.847 0 0 1 .785.515.84.84 0 0 1-.609 1.152.848.848 0 0 1-.87-.354.84.84 0 0 1 .694-1.313zM22.579 1.663a.847.847 0 0 1 .785.515.84.84 0 0 1-.609 1.152.848.848 0 0 1-.87-.354.84.84 0 0 1 .694-1.313z",
    fill: "#B19030"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61 7.524a6.954 6.954 0 0 0 2.157 4.327 7.656 7.656 0 0 0 5.156 1.974c2.204 0 4.078-.686 5.417-1.997A6.875 6.875 0 0 0 23.244 7.5a5.561 5.561 0 0 1-1.904 3.754c-1.336 1.188-3.213 1.817-5.417 1.817a8.082 8.082 0 0 1-5.156-1.79 5.724 5.724 0 0 1-2.158-3.758z",
    fill: "#B08F2F",
    fillRule: "nonzero",
    opacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.651 7.49a5.008 5.008 0 0 0 1.847 3.276 6.844 6.844 0 0 0 4.415 1.574c1.887 0 3.49-.549 4.636-1.584a4.89 4.89 0 0 0 1.63-3.272 4.345 4.345 0 0 1-1.63 2.996c-1.146.948-2.749 1.45-4.636 1.45a7.247 7.247 0 0 1-4.415-1.44 4.522 4.522 0 0 1-1.847-2.996v-.003z",
    fill: "#B08F2F",
    fillRule: "nonzero",
    opacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.877 6.116a.747.747 0 0 1 .751.74c0 .07-.01.14-.03.209v.076c0 2.68 2.952 4.993 6.329 4.993 4.341 0 6.295-2.593 6.301-5.013a.773.773 0 0 1 .578-1.05.78.78 0 0 1 .923.766.774.774 0 0 1-.482.714 5.575 5.575 0 0 1-1.904 3.754c-1.335 1.188-3.212 1.814-5.416 1.814a8.09 8.09 0 0 1-5.157-1.8 5.74 5.74 0 0 1-2.16-3.762.74.74 0 0 1-.461-.826.739.739 0 0 1 .731-.601l-.003-.014z",
    fill: "#FFF",
    fillRule: "nonzero"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.606 7.544a.74.74 0 0 1-.46-.826.738.738 0 0 1 .73-.602c.14 0 .278.037.398.11-.457.12-.808.293-.668 1.318z",
    fill: "url(#c)",
    fillRule: "nonzero"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.244 7.538a.741.741 0 0 0 .48-.706.77.77 0 0 0-.792-.783.777.777 0 0 0-.393.117c.474.123.852.31.705 1.372z",
    fill: "url(#d)",
    fillRule: "nonzero"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m2.234 3.18 1.67-1.25a.807.807 0 0 0-.534-.69L2.234.881v2.3z",
    fill: "url(#e)",
    fillRule: "nonzero"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#B19030",
    fillRule: "nonzero",
    opacity: 0.6,
    d: "m3.954 1.956.01 2.949H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.577 0c-2.856 0-4.743.562-6.396 1.997A9.142 9.142 0 0 0 9.94 7.738l-.431 2.237H4.34L0 10.444l9.932.02.043-.333.401-2.283c.464-2.56 1.31-3.957 2.946-5.358C14.958 1.088 16.848.493 19.46.493c1.002 0 1.67-.03 1.943.426-.006-.02-.21-.922-1.826-.919zM7.798 19.257h.4l.92-4.992v-.123h-.405l-.915 5.115zm10.096-9.319h-2.529l-.106.54h3.513a.913.913 0 0 0-.888-.53l.01-.01z",
    transform: "translate(7.534 12.743)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#B2B4B2",
    fillRule: "nonzero"
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m29.76 3.18-1.67-1.25a.81.81 0 0 1 .534-.69l1.135-.359v2.3z",
    fill: "url(#f)",
    fillRule: "nonzero"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#B19030",
    fillRule: "nonzero",
    opacity: 0.6,
    d: "m28.046 1.956-.01 2.949H32z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFlipkartIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/flipkartIcon.789d0401.svg";
export { ForwardRef as ReactComponent };